import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AlertService } from '../../../_shared/services/alert.service';
import { UtilService } from '../../../_shared/services/util.service';

import { Location } from '../../shared/location.model';
import { LocationService } from '../../shared/location.service';

import EDITOR_TOOLBAR from '../../../_constants/editor-toolbar';
import { NgxEditorModule, Editor, Toolbar } from 'ngx-editor';

@Component({
  selector: 'app-location-translation-modal',
  templateUrl: './location-translation-modal.component.html',
  standalone: true,
  imports: [SharedModule, NgxEditorModule],
})
export class LocationTranslationModalComponent implements OnInit, OnDestroy {
  location: Location = null;
  locationCopy = null;

  modalTitle = this.data.title;
  locationId = this.data.obj.id;
  language = this.data.params.language;

  form: FormGroup;

  editor: Editor;
  toolbar: Toolbar = EDITOR_TOOLBAR.toolbarOptions;

  serverErrors = [];
  sendingForm = false;

  constructor(
    private alertService: AlertService,
    private utilService: UtilService,
    private locationService: LocationService,
    private formBuilder: FormBuilder,
    private ref: MatDialogRef<LocationTranslationModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getLocation();
  }

  ngOnInit() {
    this.editor = new Editor();
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  // Referenced from app-item-detail-form-actions
  onSavedLocationTranslation() {
    if (this.form.invalid) {
      this.serverErrors = [];

      return;
    }

    const formData = this.form.value;

    // console.log(formData);
    // console.log(this.locationCopy);
    // return;

    const fields = ['name', 'url', 'short_description', 'long_description', 'highlights'];

    if (!fields.some((field) => formData[field] !== this.locationCopy[field])) {
      this.close();
      return;
    }

    this.sendingForm = true;

    this.locationService.saveLocation(this.location.id, formData, this.language.lang).subscribe({
      next: (response) => {
        this.alertService.open('TRANSLATION_SAVED');

        this.sendingForm = false;

        this.ref.close(response);
      },
      error: (response) => {
        this.serverErrors = this.utilService.setFormServerErrors(response.error.errors);

        this.sendingForm = false;
      },
    });
  }

  onCanceled() {
    this.close();
  }

  close() {
    this.ref.close();
  }

  private getLocation() {
    let params = {
      get: 'translate',
      lang: this.language.lang,
    };

    this.locationService.getLocation(this.locationId, params).subscribe((location) => {
      this.location = location;
      this.locationCopy = { ...this.location };

      this.setLocationTranslationForm();

      this.form.patchValue(this.location);
    });
  }

  private setLocationTranslationForm() {
    this.form = this.formBuilder.group({
      name: [
        '',
        {
          validators: [
            Validators.required,
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      url: ['', Validators.required],
      short_description: '',
      long_description: '',
      highlights: '',
    });
  }
}

/*
this.form = this.formBuilder.group({
      name: [
        this.location.name,
        {
          validators: [
            Validators.required,
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      url: [this.location.url, Validators.required],
      short_description: [this.location.short_description],
      long_description: [this.location.long_description],
      highlights: [this.location.highlights],
    });
 */

// const formData = this.utilService.deleteNullFields(fields, this.form.value);
